export const TIME_MODES = {
  ADVANCE: 'advance',
  ASAP: 'asap',
  MANUAL_FIRE: 'manualfire',
};
